import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderRecommendationTypeAppResource from "./ServiceProviderRecommendationTypeAppResource";

class ServiceProviderOrganizationListSettingAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-organization-list-setting';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/organizations/lists/settings';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'organizationUuid',
            'slot1RecommendationTypeUuid',
            'slot2RecommendationTypeUuid',
            'slot3RecommendationTypeUuid',
            'slot4RecommendationTypeUuid',
            'firstSlotType',
            'secondSlotType',
            'thirdSlotType',
            'fourthSlotType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            firstSlotType: ServiceProviderRecommendationTypeAppResource,
            secondSlotType: ServiceProviderRecommendationTypeAppResource,
            thirdSlotType: ServiceProviderRecommendationTypeAppResource,
            fourthSlotType: ServiceProviderRecommendationTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            firstSlotType: 'slot1_recommendation_type_uuid',
            secondSlotType: 'slot2_recommendation_type_uuid',
            thirdSlotType: 'slot3_recommendation_type_uuid',
            fourthSlotType: 'slot4_recommendation_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            slot1RecommendationTypeUuid: {
                type: 'string',
                presence: true,
            },
            slot2RecommendationTypeUuid: {
                type: 'string',
                presence: true,
            },
            slot3RecommendationTypeUuid: {
                type: 'string',
                presence: true,
            },
            slot4RecommendationTypeUuid: {
                type: 'string',
                presence: true,
            },
        };
    }
}

export default ServiceProviderOrganizationListSettingAppResource;
